<template>
  <div style="min-width:1000px;height:100%">
    <el-row style="height:100%;">
      <el-col :span="9" style="height:100%;">
        <div class="imger imger1" >
          <img src="./img/login/Logo@2x.png" class="logo">
          <label class="logo_span">江苏狄诺尼</label>

          <el-carousel indicator-position="outside" class="lbt" style="height:calc(100% - 100px);">
            <el-carousel-item v-for="(item,index) in lbt" :key="index" style="height:100%;">
              <img class="lbt_img" :src="item.imgUrl" />
              <div class="lbt_div">
                <label class="lbt_title">{{item.title}}</label></br>
                <div style="height:18px;"></div>
                <span class="lbt_span">{{item.text}}</span>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
      <el-col :span="15" style="height: 100%">
        <div class="imger imger2">
          <a href="http://www.jsdnn.com/" target="_blank"><span  class="fwgw">访问官网 →</span></a>
          <el-card class="box-card logins" style="width:540px;height:680px;">
            <div class="login_div">
              <router-link to="/login"><span class="bak">←返回</span></router-link>
              <span class="login_span">用户注册</span>
              <el-form style="text-align:center;" :model="registerForm" :rules="rules2" ref="registerForm">
                <el-form-item prop="name" class="register">
                  <span class="iconfont icon-yonghu" style="font-size:16px;"></span>
                  <el-input class="phone_input" style="height:48px;" type="text" v-model="registerForm.name"  auto-complete="off" placeholder="姓名"></el-input>
                </el-form-item>
                <el-form-item prop="company" class="register password">
                  <span class="iconfont icon-danweiguanli" style="font-size:16px;"></span>
                  <el-input class="phone_input"   style="height:48px;" v-model="registerForm.company" auto-complete="off" placeholder="公司全称" 
                    ></el-input>
                </el-form-item>
                <el-form-item prop="phone" class="register password">
                  <span class="iconfont icon-weibiaoti-" style="font-size:16px;"></span>
                  <el-input class="phone_input"  style="height:48px;" v-model="registerForm.phone" auto-complete="off" placeholder="手机号" 
                    ></el-input>
                </el-form-item>
                <el-form-item   prop= "smsCode"  class="register password">
                  <span class="iconfont icon-yanzhengma" style="font-size:16px;"></span>
                    <el-input   type = "text"  placeholder="验证码" class = "phone form-control"  auto-complete="off" v-model= "registerForm.smsCode"></el-input>
                    <el-button type="button"  class="el_reg"  @click="smsCode"   :disabled="disabled"  v-if="disabled==false">发送验证码
                    </el-button>
                    <el-button type="button" class="el_reg"  @click="smsCode" :disabled="disabled" v-if="disabled==true">{{btntxt}}
                    </el-button>
                </el-form-item> 

                <el-form-item prop="password" class="register password">
                  <span class="iconfont icon-mima1" style="font-size:16px;"></span>
                  <el-input class="phone" type = "text"  v-model="registerForm.password" auto-complete="off"  :class="{ 'pwd-disc': passwordHide }" placeholder="密码"> 
                    <i slot="suffix" class="el-input__icon el-icon-view" @click="passwordHide = !passwordHide"></i>
                  </el-input>
                </el-form-item>
                <el-form-item prop="conpassword" class="register password">
                  <span class="iconfont icon-querenmima1" style="font-size:16px;"></span>
                  <el-input class="phone" type = "text" v-model="registerForm.conpassword" auto-complete="off"  :class="{ 'pwd-disc': conpasswordHide }" placeholder="确认密码"> 
                    <i slot="suffix" class="el-input__icon el-icon-view" @click="conpasswordHide = !conpasswordHide"></i>
                  </el-input>
                </el-form-item>
               <!-- <el-form-item style="width:100%;margin-bottom:0px"> -->
                  <el-button type="danger" class="login_submit" @click.native.prevent="handleSubmit2" :loading="logining">提交注册</el-button>
                <!-- </el-form-item> -->
              </el-form>
            </div>
          </el-card>
          <div class="span_bottom">
            <span style="line-height:30px;">
              江苏狄诺尼信息技术有限责任公司 
            </span></br>
            <span>
              CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. <a href="https://beian.miit.gov.cn/" style="color: #666;" >苏ICP备18062906</a>
            </span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import axios from 'axios'
  import { API__code, API__login } from '../api/index.js'
  export default {

    data() {
      return{
        isCode:false,
        msg: '',
        texts: '滑动验证',
        disabled: false,
        time: 0,
        btntxt: "重新发送",
        radio: 3,
        logining: false,
        registerForm: {
          phone: '',
          password: '',
          conpassword:'',
          smsCode: '',//验证码
        },
        rules2: {
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
          ],
          company: [
            { required: true, message: '请输入公司名称', trigger: 'blur' },
          ],
          phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ],
          conpassword: [
            { required: true, message: '请确认密码', trigger: 'blur' },
          //  { required: true, message: '密码至少8位', trigger: ['blur', 'change'],min:8 },
          ],
          smsCode: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
            { required: true, message: '请输入6位验证码', trigger: ['blur', 'change'],len:6 }
          ],
          
        },
        checked: true,
        lbt:[
          {
            imgUrl:'./static/img/login/banner1@2x.png',
            title:'EICAD',
            text:'集成交互道路与立交系统 EICAD路线平面设计中，提供了智能化“路中线”实体。用户可以直接拖拽路中线上的各个夹点，以修改交点位置、圆曲线半径、缓和曲线长度、切线长和外距等设计参数，操作过程所见即所得。设计者可以忘记以往众多的设计功能命令，随心所欲地拖动调整，如同摆弄桌面上的一根绳索。'
          },
          {
            imgUrl:'./static/img/login/banner2@2x.png',
            title:'数字地面模型系统 EIDTM',
            text:'数字地面模型EIDTM模块是一个专门用于采集地形散点和等高线数据，构成三角网格，实现纵横断面剖切、地面高程坡度查询等数模应用的子系统。该模块旨在为道路工程设计者提供一套快捷、智能智能化、自动化的地形数字化及应用解决方案。软件能够在极短的时间内完成地形数字化、构网和实时剖切计算，极大的提高了数字化地形的应用效率。',
          },
          {
            imgUrl:'./static/img/login/banner3@2x.png',
            title:'BIM自动建模',
            text:'EIBIM软件提出了“线路信息模型”（Route Information Modeling）的基本实现架构，并实现了其技术途径。在EICAD模型成果的基础上，导出线路信息模型数据，利用Revit二次开发工具，实现道路信息模型的无缝转换、同步更新；并建立公路工程常用桥隧BIM构件库；开发桥隧工程的自动建模功能。EIBIM从根本上解决了上述难题。',
          }
        ],
        passwordHide: true,
        conpasswordHide: true
      }
    },
    methods: {
        //发送验证码
        smsCode() {
          if (this.registerForm.phone == '') {
              this.$message({
                  message:'手机号不能为空',
                  center: true
              })
              return;
          }
          let para = {
              phone: this.registerForm.phone
          };
          API__login.sendSmsCodeds(para)
          .then((res) =>{
              if(res.data.code == API__code.SUCCESS ){
                  this.$message({
                      message: '发送成功',
                      type: 'success',
                      center:true
                  });
                  this.time = 120;
                  this.disabled = true;
                  this.timer();
              }else{
                  this.$message.error(res.data.message);
              }
          }).catch(err =>{
                this.$message.error('服务器异常，请您稍后再试..');
                this.pageLoading = false;
          });
      },
      //60S倒计时
      timer() {
          if (this.time > 0) {
              this.time--;
              this.btntxt = this.time + "s后重新获取";
              setTimeout(this.timer, 1000);
          } else {
              this.time = 0;
              this.btntxt = "获取验证码";
              this.disabled = false;
          }
      },

      handleSubmit2(formName) {
        this.$refs.registerForm.validate((valid) => {
          if (valid) {
            this.register();
          } else {
            this.$message.error('请正确输入注册信息..');
            return false;
          }
        });
      },
      // 注册
      register() {
        this.pageLoading = true;
        let param ={
          password:this.registerForm.password,
          conpassword:this.registerForm.conpassword,
          phone:this.registerForm.phone,
          userType:'0',//用户类型
          smsCode:this.registerForm.smsCode,
          company:this.registerForm.company,
          name:this.registerForm.name,
        }
        API__login.register(param)
        .then( (res) => {
          if( res.data.code == API__code.SUCCESS ) {
            this.$message({
              message: '注册成功',
              type: 'success'
            });
            this.$router.push({path: 'login'});
          }else {
            this.$message.error(res.data.message);
          }
          this.pageLoading = false;
        }).catch( e => {
          this.$message.error('服务器异常，请您稍后再试..');
          this.pageLoading = false;
        });
      },
    },
    created(){
     
    }
  }
</script>
<style lang="scss" scoped>
.fwgw{
  color:#F66B3D;
  font-size:16px;
  position:relative;
  float:right;
  right:60px;
  top:33px;
}
.lbt{
  position: relative;
  left: 50%;
  top:100px;
  -webkit-transform: translate(-50%,0);
  -ms-transform: translate(-50%,0);
  transform: translate(-50%,0);
}
.imger{
  height:100%;
  width: 100%;
  background-size: cover;
}
.imger1{    
  background:  url('./img/login/BG2@2x.png');
}
.imger2{  
  background:  url('./img/login/BG1@2x.png');
  background-size: 100%;
}
.logo{
  width: 32px;
  height: 32px;
  position: absolute;
  left: 42px;
  top: 32px;
}
.logo_span{
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  position: absolute;
  left: 85px;
  top: 35px;
  font-family: "思源黑体 CN Bold Bold";
}
.logins{
  position: relative;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}
.login_span{
  font-weight: bold;
  font-size: 24px;
  font-family: "思源黑体 CN Bold Bold";
  color:#F66B3D;
}
.login_div{
  text-align:center;
  position: relative;
  top:25px;
}
.register{
  width:400px;
  height: 40px;
  margin: 0 auto;
  font-size: 16px;
  position: relative;
  top: 45px;
}
.phone_input{
  width:400px;
  height: 60px;
  font-size: 16px;
}
.password{
  padding-top: 30px;
}
.login_submit{
  background-color:#F66B3D;width: 400px;
  background-color: rgb(246, 107, 61);
  height: 60px;
  position: relative;
  top: 90px;
  font-size: 20px;
  font-weight: Normal;
  font-family: "思源黑体 CN Bold Bold";
}
.tips {
    float: right;
    margin: 30px 50px 0 0;
    position: relative;
    top: 85px;
    font-size: 14px;
    color:#666666;
}
.tips a {
    color: rgb(204, 204, 204);
    margin-left: 20px;
    cursor: pointer;
}
.lbt_img{
  width:500px;
  height:500px;
  clear: both; 
  display: block; 
  margin:auto; 
}
.lbt_div{
  text-align:center;
  width:82%;
  position:relative;
  left:9%;
}
.lbt_span{
  line-height: 24px;
  font-size: 14px;
  font-weight: normal;
  font-family: "思源黑体 CN Normal";
  color: #fff;
}
.lbt_title{
  line-height: 42px;
  font-size: 28px;
  font-weight: bold;
  font-family: "思源黑体 CN Normal";
  padding-bottom: 18px;
  color: #fff;
}
.span_bottom{
  text-align:center;
  bottom: 30px;
  position: absolute;
  font-size:14px;
  color:#666666;
  text-align: center;
  width: 62.5%;
}
.el_reg{
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    background: #ecf5ff;
    color: #F66B3D;
    border-radius: 0 4px 4px 0;
    border-color: #c6e2ff;
    border-left-color: #F66B3D;
    &:hover{
        background: #c8e2ff;
    }
}
.bak{
  color:#333333;
  font-size:16px;
  position: absolute;
  float: left;;
  left:35px;
  top:7px;
}

</style>


// WEBPACK FOOTER //
// Register.vue?9dbfb27e